export default __webpack_public_path__ + "static/media/Agent-StoreAssignment-Sample.4b1c7388.csv";